import { useContext } from 'react'
import { ProfileRoleContext } from 'app/contexts/ProfileRoleContext'

export function useRole() {
  const context = useContext(ProfileRoleContext)

  return context
}